export enum NotificationRelativeToType {
  slaDeadline = 0,
  slaGoal = 1,
  stepStart = 2,
  stepEnd = 3
}
